<template>
    <div class="register-page login-page_common">
        <div>
            <div class="register-page__content content-padding">
                <a-form-model ref="form" :model="form" :rules="rules">
                    <a-form-model-item prop="phoneNumber">
                        <a-input
                            v-model="form.phoneNumber"
                            size="large"
                            placeholder="请输入手机号"
                        >
                            <div
                                slot="prefix"
                                :style="{ color: 'rgba(0,0,0,.25)' }"
                            >
                                <img
                                    width="16px"
                                    src="@assets/images/icon/phone.png"
                                    alt=""
                                    srcset=""
                                >
                            </div>
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item prop="verificationCode">
                        <a-row>
                            <a-col :span="14">
                                <a-input
                                    v-model="form.verificationCode"
                                    size="large"
                                    placeholder="请输入短信验证码"
                                >
                                    <div
                                        slot="prefix"
                                        :style="{ color: 'rgba(0,0,0,.25)' }"
                                    >
                                        <img
                                            width="16px"
                                            src="@/assets/images/icon/phone-code.png"
                                            alt=""
                                            srcset=""
                                        >
                                    </div>
                                </a-input>
                            </a-col>
                            <a-col :span="10">
                                <button
                                    :disabled="disabledSendBtn"
                                    class="sdk-login-page_common-checkcode"
                                    @click="handleSendCode('form')"
                                >
                                    {{ sendText }}
                                </button>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                    <a-form-model-item
                        prop="password"
                        :rules="[{
                            required: true,
                            message: '请输入',
                            trigger: 'blur',
                        }, { validator: validatePassword }]">
                        <a-input-password
                            v-model="form.password"
                            size="large"
                            placeholder="请设置登录密码"
                        >
                            <div
                                slot="prefix"
                                :style="{ color: 'rgba(0,0,0,.25)' }"
                            >
                                <img
                                    width="16px"
                                    src="@assets/images/icon/password.png"
                                    alt=""
                                    srcset=""
                                >
                            </div>
                        </a-input-password>
                    </a-form-model-item>
                    <a-form-model-item
                        prop="confirmPassword"
                        :rules="[{
                                     required: true,
                                     message: '请输入',
                                     trigger: 'blur',
                                 }, { validator: validatePassword },
                                 { validator: validateConfirmPassword }]">
                        <a-input-password
                            v-model="form.confirmPassword"
                            size="large"
                            placeholder="确认密码"
                        >
                            <div
                                slot="prefix"
                                :style="{ color: 'rgba(0,0,0,.25)' }"
                            >
                                <img
                                    width="16px"
                                    src="@assets/images/icon/password.png"
                                    alt=""
                                    srcset=""
                                >
                            </div>
                        </a-input-password>
                    </a-form-model-item>
                    <a-form-model-item
                        style="margin-bottom: 0"
                        prop="agreement"
                        :rules="[{required:true,message:'请勾选',trigger:'input'}]">
                        <div class="register-page__agreement">
                            <a-radio :checked="form.agreement" @change="form.agreement = true">
                                <span class="user-select_common">
                                    <span>我已阅读并同意</span>
                                    <a-button
                                        style="padding-left: 0;padding-right: 0"
                                        type="link"
                                        @click="handleAgreement"
                                    >《用户服务协议》
                                    </a-button>
                                    <a-button
                                        style="padding-left: 0"
                                        type="link"
                                        @click="handlePrivacy"
                                    >《隐私权政策》
                                    </a-button>
                                </span>
                            </a-radio>
                        </div>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button
                            class="submit-button"
                            size="large"
                            type="primary"
                            :loading="loading"
                            :disabled="loading"
                            @click="handleSubmit"
                        >
                            立即注册
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
                <div class="form-footer">
                    <a v-if="showForgetPsdBtn" @click="handleForgetPsd"> 忘记密码 </a>
                    <span v-else />
                    <a @click="handleLogin">
                        <span class="form-footer__account-color"
                        >已经有账号，去</span
                        >登录
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Row as ARow,
    Col as ACol,
    FormModel as AFormModel,
    Input as AInput,
    Button as AButton,
    Radio as ARadio
} from 'ant-design-vue'
import { validatePassword } from '@constant/validates'
import { RegPhone, RegSendNumber } from '@utils/regExp'
// 短信验证码的mixins
import VerfiyCodeMixins from '@/mixins/verfiyCode'

import { AUTOMATICALLY_MATCHES_SUPERVISOR_REGION_ENABLED } from '@constant/enum'

import phoneRegisterService from '@service/login/phoneRegisterService'
function createForm() {
    return {
        phoneNumber: '',
        verificationCode: '',
        password: '',
        confirmPassword: '',
        agreement: false
    }
}
export default {
    name: 'RegisterView',
    components: {
        ARadio,
        AInput,
        AInputPassword: AInput.Password,
        AButton,
        ARow,
        ACol,
        AFormModel,
        AFormModelItem: AFormModel.Item
    },
    mixins: [VerfiyCodeMixins],
    props: {
        params: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            validatePassword,
            RegPhone,
            RegSendNumber,
            loading: false,
            title: '新用户注册',
            orAgreement: false,
            headCardStyle: {
                color: '#1877F2'
            },
            form: createForm(),
            rules: {
                phoneNumber: [
                    {
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur'
                    },
                    {
                        pattern: RegPhone,
                        trigger: 'blur',
                        message: '请输入正确格式的手机号'
                    }
                ],
                verificationCode: [
                    {
                        required: true,
                        message: '输入短信验证码',
                        trigger: 'blur'
                    }
                    // {
                    //   trigger: "blur",
                    //   pattern: RegSendNumber,
                    //   message: "请输入正确的短信验证码",
                    // },
                ]
            }
        }
    },
    computed: {
        showForgetPsdBtn() {
            const competentAreaAutoMatch = this.$store.getters.initInformation?.competentAreaAutoMatch
            return competentAreaAutoMatch !== AUTOMATICALLY_MATCHES_SUPERVISOR_REGION_ENABLED
        }
    },
    methods: {
        validateConfirmPassword(rule, value, callback) {
            const { password } = this.form
            if (password === value) {
                callback()
            } else {
                callback(new Error(`确认密码与登录密码不一致`))
            }
        },
        handleSubmit() {
            this.loading = true
            this.$refs.form.validate(async valid => {
                if (valid) {
                    try {
                        // await this.$store.dispatch("loginByUserName", values);
                        this.handleRegister()
                    } catch (error) {
                        this.$message.error(error)
                    } finally {
                        this.loading = false
                    }
                } else {
                    this.loading = false
                    return false
                }
            })
        },
        async handleRegister() {
            try {
                await phoneRegisterService(this.form)
                this.$message.success('注册成功')
                this.successCb()
                this.handleLogin()
                // goSetPassword({
                //     ac: result.token
                // })
            } catch (error) {
                const { message } = error
                this.$message.error(message)
            }
        },
        successCb() {
            this.form = createForm()
            this.clear()
        },
        // 服务协议
        handleAgreement(e) {
            e.preventDefault()
            window.open('/userServe.html')
        },
        // 隐私
        handlePrivacy() {
            window.open('/privacyPolicy.html')
        },
        handleLogin() {
            this.$emit('login')
        },
        handleForgetPsd() {
            this.$emit('forget-psd')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@assets/styles/varibles.scss';

@import '@assets/styles/common.scss';

.register-page {
    width: 100%;
    height: 100%;
    //position: relative;
    //background-size: cover;
    //background-position: center;
    //background-color: #fff;

    &__submit-button {
        width: 100%;
    }

    button:disabled {
        color: rgba(0, 0, 0, 0.25) !important;
        background-color: #f5f5f5 !important;
        border-color: #d9d9d9 !important;
        text-shadow: none !important;
        box-shadow: none !important;
        cursor: not-allowed;
    }
}

.sdk-login-page_common-checkcode {
    height: 56px;
}
</style>
